<template>
    <div class="join-view">
        <van-form ref="prefill" @submit="onSubmit" class="form-box">
            <h5>基本信息</h5>
            <van-cell-group inset>
                <van-field
                    v-model="idCardNum"
                    name="idcard_num"
                    label="身份证号"
                    placeholder="身份证号"
                    :rules="[{ required: true, message: '请填写身份证号' }]"
                />

                <van-field
                    v-model="mobile"
                    name="mobile"
                    label="手机号"
                    placeholder="手机号"
                    :rules="[{ required: true, message: '请填写手机号' }]"
                />

                <van-field
                    v-model="prefill_nickname"
                    name="prefill_nickname"
                    label="昵称"
                    placeholder="用户昵称"
                    :rules="[{ required: true, message: '昵称由汉字、字母、数字和下划线组成。最少1个汉字或者2个字母/数字，最多8个汉字或者最多16个字母/数字(不超过16个字符)' }]"
                />

                <van-field name="is_only_son" label="独生子女">
                    <template #input>
                        <van-radio-group v-model="is_only_son" direction="horizontal">
                            <van-radio name="1">是</van-radio>
                            <van-radio name="0">否</van-radio>
                        </van-radio-group>
                    </template>
                </van-field>

                <van-field
                    v-model="marriageText"
                    is-link
                    readonly
                    label="婚姻状态"
                    placeholder="选择婚姻状态"
                    @click="marriageShow = true"
                />

                <van-field
                    v-model="childrenInfoText"
                    is-link
                    readonly
                    label="子女状态"
                    placeholder="选择子女状态"
                    @click="childrenInfoShow = true"
                />
                <van-field
                    v-model="educationText"
                    is-link
                    readonly
                    label="学历"
                    placeholder="选择学历"
                    @click="educationShow = true"
                />
                <van-field v-if="education > 16"
                           v-model="school"
                           name="school"
                           label="毕业院校"
                           placeholder="毕业院校"
                />
                <van-field v-if="education > 16"
                           v-model="major"
                           name="major"
                           label="专业"
                           placeholder="专业"
                />
                <van-field
                    v-model="family"
                    label="家庭成员"
                    placeholder="家庭成员"
                />
            </van-cell-group>

            <h5>经济状况</h5>
            <van-cell-group inset>
                <van-field
                    v-model="carText"
                    is-link
                    readonly
                    label="车"
                    placeholder="选择车辆状况"
                    @click="carShow = true"
                />

                <van-field
                    v-if="car > 2"
                    v-model="carPriceText"
                    is-link
                    readonly
                    label="车辆价格"
                    placeholder="选择车辆价格"
                    @click="carPriceShow = true"
                />

                <van-field
                    v-model="houseText"
                    is-link
                    readonly
                    label="房"
                    placeholder="选择房产状况"
                    @click="houseShow = true"
                />

                <van-field
                    v-if="house > 2"
                    v-model="housePriceText"
                    is-link
                    readonly
                    label="房产价格"
                    placeholder="选择房产价格"
                    @click="housePriceShow = true"
                />
                <van-field
                    label="工作地"
                    v-model="areaText"
                    is-link
                    readonly
                    placeholder="选择工作地"
                    @click="show = true"
                />

                <van-field
                    label="职业"
                    v-model="jobText"
                    is-link
                    readonly
                    placeholder="选择职业"
                    @click="jobShow = true"
                />

                <van-field
                    v-model="salaryText"
                    is-link
                    readonly
                    label="月收入"
                    placeholder="选择月收入"
                    @click="salaryShow = true"
                />

                <van-field
                    v-model="work_unit"
                    name="work_unit"
                    label="工作单位"
                    placeholder="工作单位"
                />
            </van-cell-group>


            <h5>择偶条件</h5>
            <van-cell-group inset>
                <van-field
                    v-model="expectMinSalaryText"
                    is-link
                    readonly
                    label="最低收入"
                    placeholder="选择期望最低收入"
                    @click="expectMinSalaryShow = true"
                />
                <van-field
                    v-model="expectMinEducationText"
                    is-link
                    readonly
                    label="最低学历"
                    placeholder="选择期望最低学历"
                    @click="expectMinEducationShow = true"
                />
                <van-field
                    label="地区"
                    v-model="expectResideText"
                    is-link
                    readonly
                    placeholder="选择期望择偶地区"
                    @click="expectResideShow = true"
                />

                <van-field
                    v-model="expectMarriageText"
                    is-link
                    readonly
                    label="婚姻状态"
                    placeholder="选择期望婚姻状态"
                    @click="expectMarriageShow = true"
                />
                <van-field
                    v-model="expectHealthText"
                    is-link
                    readonly
                    label="身体状态"
                    placeholder="选择期望身体状态"
                    @click="expectHealthShow = true"
                />

                <van-field
                    v-model="expectHeightText"
                    is-link
                    readonly
                    label="期望身高"
                    placeholder="选择期望身高"
                    @click="expectHeightShow = true"
                />

                <van-field
                    v-model="expectAgeText"
                    is-link
                    readonly
                    label="期望年龄"
                    placeholder="选择期望年龄"
                    @click="expectAgeShow = true"
                />

            </van-cell-group>

            <h5>婚姻状态证明</h5>
            <van-cell-group inset>
                <van-field name="uploader" label="婚姻状态截图">
                    <template #input>
                        <van-uploader :after-read="imgAfterRead" v-model="imgList" multiple :max-count="4"/>
                    </template>
                </van-field>

                <van-field name="uploader" label="婚姻状态视频">
                    <template #input>
                        <van-uploader id="video" :before-read="videoBeforeRead" :after-read="videoAfterRead" multiple :max-count="1" :before-delete="videoDel" v-model="videoList" accept="video/*" />
                        <van-button v-if=" videoUrl !== '' " icon="play-circle" type="primary" @click="videoShow = true"/>
                    </template>
                </van-field>

                <van-field name="uploader" label="演示视频">
                    <template #input>
                        <div style="width: 80px;height:80px;background-color:#F7F8FA;line-height:70px;text-align:center;">
                            <van-button icon="play-circle" color="#fe405f" @click="demoVideoShow = true"/>
                        </div>
                    </template>
                </van-field>
<!--                <video width="320" height="240" controls src="https://ayz-dev.oss-cn-shanghai.aliyuncs.com/i/papers/250112/17366609234rpj2cmq.mp4"></video>-->
            </van-cell-group>

            <div style="margin: 16px;">
                <van-button round block v-model:disabled="disabled" color="#fe405f" native-type="submit">
                    提交
                </van-button>
            </div>
        </van-form>


    </div>
    <van-overlay :show="demoVideoShow" @click="demoVideoShow = false">
        <div class="wrapper" @click="demoVideoShow = false">
            <div class="block">
                <div class="close" @click="demoVideoShow = false">X 关闭</div>
                <video width="80%" height="80%" controls autoplay :src="demoVideoUrl"></video>
            </div>
        </div>
    </van-overlay>

    <van-overlay :show="videoShow" @click="videoShow = false">
        <div class="wrapper" @click="videoShow = false">
            <div class="block">
                <div class="close" @click="videoShow = false">X 关闭</div>
                <video width="80%" height="80%" controls autoplay :src="videoUrl"></video>
            </div>
        </div>
    </van-overlay>

    <van-popup v-model:show="show" destroy-on-close round position="bottom">
        <van-area :area-list="areaList"
                  @cancel="show = false"
                  @confirm="areaConfirm"
        />
    </van-popup>

    <van-popup v-model:show="marriageShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="marriageValue"
            :columns="marriageData"
            @cancel="marriageShow = false"
            @confirm="marriageConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectMarriageShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectMarriageValue"
            :columns="expectMarriageData"
            @cancel="expectMarriageShow = false"
            @confirm="expectMarriageConfirm"
        />
    </van-popup>

    <van-popup v-model:show="childrenInfoShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="childrenInfoValue"
            :columns="childrenInfoData"
            @cancel="childrenInfoShow = false"
            @confirm="childrenInfoConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectHeightShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectHeightValue"
            :columns="expectHeightData"
            @cancel="expectHeightShow = false"
            @confirm="expectHeightConfirm"
        />
    </van-popup>

    <van-popup v-model:show="educationShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="educationValue"
            :columns="educationData"
            @cancel="educationShow = false"
            @confirm="educationConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectMinEducationShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectMinEducationValue"
            :columns="educationData"
            @cancel="expectMinEducationShow = false"
            @confirm="expectMinEducationConfirm"
        />
    </van-popup>

    <van-popup v-model:show="jobShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="JobValue"
            :columns="jobList"
            @cancel="jobShow = false"
            @confirm="jobConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectResideShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectResideValue"
            :columns="expectResideList"
            @cancel="expectResideShow = false"
            @confirm="expectResideConfirm"
        />
    </van-popup>

    <van-popup v-model:show="salaryShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="salaryValue"
            :columns="salaryData"
            @cancel="salaryShow = false"
            @confirm="salaryConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectMinSalaryShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectMinSalaryValue"
            :columns="salaryData"
            @cancel="expectMinSalaryShow = false"
            @confirm="expectMinSalaryConfirm"
        />
    </van-popup>

    <van-popup v-model:show="carShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="carValue"
            :columns="carData"
            @cancel="carShow = false"
            @confirm="carConfirm"
        />
    </van-popup>

    <van-popup v-model:show="carPriceShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="carPriceValue"
            :columns="carPriceData"
            @cancel="carPriceShow = false"
            @confirm="carPriceConfirm"
        />
    </van-popup>


    <van-popup v-model:show="houseShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="houseValue"
            :columns="houseData"
            @cancel="houseShow = false"
            @confirm="houseConfirm"
        />
    </van-popup>

    <van-popup v-model:show="housePriceShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="housePriceValue"
            :columns="housePriceData"
            @cancel="housePriceShow = false"
            @confirm="housePriceConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectHealthShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectHealthValue"
            :columns="expectHealthData"
            @cancel="expectHealthShow = false"
            @confirm="expectHealthConfirm"
        />
    </van-popup>

    <van-popup v-model:show="expectAgeShow" destroy-on-close round position="bottom">
        <van-picker
            :model-value="expectAgeValue"
            :columns="expectAgeData"
            @cancel="expectAgeShow = false"
            @confirm="expectAgeConfirm"
        />
    </van-popup>

</template>
<script>

import ayzAjax from "@/plugins/axios";
import {closeToast, showFailToast, showLoadingToast, showSuccessToast} from "vant";

export default {
    name: "JoinView",
    data: function () {
        return {
            // loadingShow:true,
            demoVideoShow:false,
            videoShow:false,
            isSubmit:false,
            imgList:[],
            videoList:[],
            disabled:false,
            show:false,
            areaText:'',
            adCodes:'',
            idCardNum: '',
            mobile: '',
            prefill_nickname: '',
            work_unit:'',
            family:'',
            school:'',
            major:'',
            address: '',
            areaList: [],
            jobShow:false,
            jobList: [],
            jobText:'',
            JobValue:[],
            job:null,
            marriageData:[],
            marriageText:'',
            marriageValue:[],
            marriageShow:false,
            marriage:null,
            expectMarriageData:[],
            expectMarriageText:'',
            expectMarriageValue:[],
            expectMarriageShow:false,
            expectMarriage:null,
            childrenInfoData:[],
            childrenInfoText:'',
            childrenInfoValue:[],
            childrenInfoShow:false,
            childrenInfo:null,
            educationData : null,
            educationText:'',
            educationShow: false,
            educationValue:[],
            education:null,
            expectMinEducationText:'',
            expectMinEducationShow: false,
            expectMinEducationValue:[],
            expectMinEducation:null,
            is_only_son:1,
            salaryData:[],
            salaryText:'',
            salaryValue:[],
            salaryShow:false,
            salary:null,
            expectMinSalaryText:'',
            expectMinSalaryValue:[],
            expectMinSalaryShow:false,
            expectMinSalary:null,
            carData:[],
            carText:'',
            carValue:[],
            carShow:false,
            car:null,
            carPriceData:[],
            carPriceText:'',
            carPriceValue:[],
            carPriceShow:false,
            carPrice:null,
            houseData:[],
            houseText:'',
            houseValue:[],
            houseShow:false,
            house:null,
            housePriceData:[],
            housePriceText:'',
            housePriceValue:[],
            housePriceShow:false,
            housePrice:null,
            expectHealthData:[],
            expectHealthText:'',
            expectHealthValue:[],
            expectHealthShow:false,
            expectHealth:null,
            expectHeightData:[],
            expectHeightText:'',
            expectHeightValue:[],
            expectHeightShow:false,
            expectMinHeight:null,
            expectMaxHeight:null,
            expectAgeData:[],
            expectAgeText:'',
            expectAgeValue:[],
            expectAgeShow:false,
            expectMinAge:null,
            expectMaxAge:null,
            imageUrl:[],
            demoVideoUrl:'/video/demo.mp4',
            videoUrl:'',
            expectResideValue:[],
            expectResideList:[],
            expectResideProvinceId:null,
            expectResideCityId:null,
            expectResideShow:false,
            expectResideText:'',

        }
    },
    created() {
        this.getPrefillData();
    },
    methods: {
        //图片上传
        imgAfterRead(file){
            const formData = new FormData();
            formData.append('file', file.file);
            formData.append('object_key', 'i/papers/');
            formData.append('object_type', 'image');
            ayzAjax.post('/upload_file',formData,{
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if(response.data.code !== 200){
                    showFailToast('提交失败,请稍后再试')
                    return false;
                }
                this.imageUrl.push(response.data.data.url);
                console.log(this.imageUrl);
            })
        },
        //视频上传
        videoAfterRead(file){
            this.isSubmit = true;
            showLoadingToast({
                duration: 0,
                message: '上传中...',
                loadingType: 'spinner',
            });
            const formData = new FormData();
            formData.append('file', file.file);
            formData.append('object_key', 'i/papers/');
            formData.append('object_type', 'video');
            ayzAjax.post('/upload_file',formData,{
                timeout:300000,
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then((response) => {
                if(response.data.code !== 200){
                    showFailToast('提交失败,请稍后再试')
                    return false;
                }
                this.videoUrl = response.data.data.url;
                closeToast();
                this.isSubmit = false;
            }).catch(error => {
                console.error('请求超时或发生错误', error);
                showFailToast('请求超时或文件大于50M')
            });
        },
        //视频上传前的操作
        videoBeforeRead(file){
            if (file.type !== 'video/mp4') {
                // showFailToast('请上传MP4格式的视频');
                // return false;
            }
            return true;
        },

        videoDel(){
            this.videoList = [];
            this.videoUrl = '';
        },
        //职业
        jobConfirm({selectedOptions}){
            this.jobShow = false;
            this.jobText = selectedOptions.map((option) => option.text).join(' ');
            this.job = selectedOptions[1].value;
        },
        //婚姻状态
        marriageConfirm({ selectedValues, selectedOptions }){
            this.marriageShow = false;
            this.marriageValue = selectedValues;
            this.marriageText = selectedOptions[0].text;
            this.marriage = selectedOptions[0].value;
        },
        //期望婚姻状态
        expectMarriageConfirm({ selectedValues, selectedOptions }){
            this.expectMarriageShow = false;
            this.expectMarriageValue = selectedValues;
            this.expectMarriageText = selectedOptions[0].text;
            this.expectMarriage = selectedOptions[0].value;
        },
        //子女状态
        childrenInfoConfirm({ selectedValues, selectedOptions }){
            this.childrenInfoShow = false;
            this.childrenInfoValue = selectedValues;
            this.childrenInfoText = selectedOptions[0].text + ' ' + selectedOptions[1].text;
            this.childrenInfo = parseInt(selectedOptions[0].value) + parseInt(selectedOptions[1].value);
        },
        //期望身高
        expectHeightConfirm({ selectedValues, selectedOptions }){
            this.expectHeightShow = false;
            this.expectHeightValue = selectedValues;
            this.expectHeightText = selectedOptions[0].text + ' - ' + selectedOptions[1].text;
            this.expectMinHeight = selectedOptions[0].value;
            this.expectMaxHeight = selectedOptions[1].value;
        },
        //学历
        educationConfirm({ selectedValues, selectedOptions }){
            this.educationShow = false;
            this.educationValue = selectedValues;
            this.educationText = selectedOptions[0].text;
            this.education = selectedOptions[0].value;
        },
        //最低学历
        expectMinEducationConfirm({ selectedValues, selectedOptions }){
            this.expectMinEducationShow = false;
            this.expectMinEducationValue = selectedValues;
            this.expectMinEducationText = selectedOptions[0].text;
            this.expectMinEducation = selectedOptions[0].value;
        },
        //月收入
        salaryConfirm({ selectedValues, selectedOptions }){
            this.salaryShow = false;
            this.salaryValue = selectedValues;
            this.salaryText = selectedOptions[0].text;
            this.salary = selectedOptions[0].value;
        },
        //期望最低月收入
        expectMinSalaryConfirm({ selectedValues, selectedOptions }){
            this.expectMinSalaryShow = false;
            this.expectMinSalaryValue = selectedValues;
            this.expectMinSalaryText = selectedOptions[0].text;
            this.expectMinSalary = selectedOptions[0].value;
        },
        //车
        carConfirm({ selectedValues, selectedOptions }){
            this.carShow = false;
            this.carValue = selectedValues;
            this.carText = selectedOptions[0].text;
            this.car = selectedOptions[0].value;
        },
        //车价格
        carPriceConfirm({ selectedValues, selectedOptions }){
            this.carPriceShow = false;
            this.carPriceValue = selectedValues;
            this.carPriceText = selectedOptions[0].text;
            this.carPrice = selectedOptions[0].value;
        },
        //房
        houseConfirm({ selectedValues, selectedOptions }){
            this.houseShow = false;
            this.houseValue = selectedValues;
            this.houseText = selectedOptions[0].text;
            this.house = selectedOptions[0].value;
        },
        //房价格
        housePriceConfirm({ selectedValues, selectedOptions }){
            this.housePriceShow = false;
            this.housePriceValue = selectedValues;
            this.housePriceText = selectedOptions[0].text;
            this.housePrice = selectedOptions[0].value;
        },
        //期望身体状态
        expectHealthConfirm({ selectedValues, selectedOptions }){
            this.expectHealthShow = false;
            this.expectHealthValue = selectedValues;
            this.expectHealthText = selectedOptions[0].text;
            this.expectHealth = selectedOptions[0].value;
        },
        //工作地
        areaConfirm(res) {
            this.areaText = `${res.selectedOptions[0].text} ${res.selectedOptions[1].text} ${res.selectedOptions[2].text}`;
            this.adCodes = `${res.selectedOptions[0].value},${res.selectedOptions[1].value},${res.selectedOptions[2].value}`;
            this.show = false;
        },
        //期望择偶地区
        expectResideConfirm({selectedOptions}){
            this.expectResideShow = false;
            this.expectResideText = selectedOptions.map((option) => option.text).join(' ');
            this.expectResideProvinceId = selectedOptions[0].value;
            this.expectResideCityId = selectedOptions[1].value;
        },
        //期望年龄
        expectAgeConfirm({ selectedValues, selectedOptions }){
            this.expectAgeShow = false;
            this.expectAgeValue = selectedValues;
            this.expectAgeText = selectedOptions[0].text + ' - ' + selectedOptions[1].text;
            this.expectMinAge = selectedOptions[0].value;
            this.expectMaxAge = selectedOptions[1].value;
        },
        //获取预填选项数据
        getPrefillData(){
            this.marriageData = [{value:"1",text:"未婚"},{value:"2",text:"离异"},{value:"4",text:"丧偶"}];
            this.expectMarriageData = [{value:"7",text:"不限"},{value:"1",text:"未婚"},{value:"2",text:"离异"},{value:"4",text:"丧偶"}];
            this.childrenInfoData = [
                [{value:"0",text:"无子"},{value:"2",text:"带一男孩"},{value:"4",text:"带俩男孩"},{value:"8",text:"带三男孩"}],
                [{value:"0",text:"无女"},{value:"16",text:"带一女孩"},{value:"32",text:"带俩女孩"},{value:"64",text:"带三女孩"}]
            ];
            this.educationData =  [{value:"1",text:"无学历"},{value:"2",text:"小学"},{value:"4",text:"初中"},{value:"8",text:"中专"},{value:"16",text:"高中"},{value:"32",text:"大专"},{value:"64",text:"本科"},{value:"128",text:"硕士"},{value:"256",text:"博士"}];
            this.salaryData =  [{value:"1000",text:"1000"},{value:"2000",text:"2000"},{value:"3000",text:"3000"},{value:"4000",text:"4000"},{value:"5000",text:"5000"},{value:"6000",text:"6000"},{value:"7000",text:"7000"},{value:"8000",text:"8000"},{value:"9000",text:"9000"},{value:"10000",text:"1W"},{value:"15000",text:"1.5W"},{value:"20000",text:"2W"},{value:"30000",text:"3W"},{value:"40000",text:"4W"},{value:"50000",text:"5W"},{value:"70000",text:"7W"},{value:"100000",text:"10W"},{value:"200000",text:"20W"},{value:"500000",text:"50W"},{value:"1000000",text:"100W"},{value:"1500000",text:"100W以上"}];
            this.carData =  [{value:"1",text:"无车"},{value:"2",text:"需要时购车"},{value:"4",text:"有车"}];
            this.carPriceData =  [{value:"5",text:"10W以下"},{value:"15",text:"10-20W"},{value:"25",text:"20-30W"},{value:"40",text:"30-50W"},{value:"75",text:"50-100W"},{value:"150",text:"100W以上"}];
            this.houseData = [{value:"1",text:"无房"},{value:"2",text:"需要时购房"},{value:"4",text:"自建房"},{value:"8",text:"商品房"},{value:"16",text:"自建别墅"},{value:"32",text:"商品别墅"}];
            this.housePriceData =  [{value:"10",text:"20W以下"},{value:"25",text:"20-30W"},{value:"40",text:"30-50W"},{value:"75",text:"50-100W"},{value:"125",text:"100-150W"},{value:"175",text:"150-200W"},{value:"250",text:"200-300W"},{value:"400",text:"300-500W"},{value:"550",text:"500W以上"}];
            this.expectHealthData =  [{value:"15",text:"不限"},{value:"1",text:"健康"},{value:"2",text:"残疾"},{value:"4",text:"聋哑"},{value:"8",text:"盲人"}];
            let minHeight = [];
            for (let i = 50; i <= 240; i = (i+5)){
                let heightItem = {}
                heightItem.value = i;
                heightItem.text = i + 'cm';
                minHeight.push(heightItem);
            }
            let maxHeight = [];
            for (let i = 55; i <= 240; i = (i+5)){
                let heightItem = {}
                heightItem.value = i;
                heightItem.text = i + 'cm';
                maxHeight.push(heightItem);
            }
            this.expectHeightData = [minHeight,maxHeight];


            let minAge = [];
            for (let i = 18; i <= 80; i = (i+2)){
                let AgeItem = {}
                AgeItem.value = i;
                AgeItem.text = i;
                minAge.push(AgeItem);
            }
            let maxAge = [];
            for (let i = 20; i <= 80; i = (i+2)){
                let AgeItem = {}
                AgeItem.value = i;
                AgeItem.text = i;
                maxAge.push(AgeItem);
            }
            this.expectAgeData = [minAge, maxAge];

            ayzAjax.get('/get_area').then((response) => {
                if(response.data.code !== 200){
                    showFailToast(response.data.msg);
                    return false;
                }
                this.areaList = response.data.data;
            })

            ayzAjax.get('/get_job').then((response) => {
                if(response.data.code !== 200){
                    showFailToast(response.data.msg);
                    return false;
                }
                this.jobList = response.data.data;
            })
            ayzAjax.get('/get_expect_reside').then((response) => {
                if(response.data.code !== 200){
                    showFailToast(response.data.msg);
                    return false;
                }
                this.expectResideList = response.data.data;
            })

        },
        //提交
        onSubmit(fromData){
            if (this.isSubmit === true) {
                return false;
            }
            if (fromData['idcard_num'].length < 18) {
                showFailToast('请输入正确的身份证号');
                return false;
            }
            let phoneRegex = /^[1][3-9][0-9]{9}$/
            if (!phoneRegex.test(fromData['mobile'])) {
                showFailToast('请输入正确的手机号');
                return false;
            }

            fromData['marriage'] = this.marriage;
            fromData['children_info'] = this.childrenInfo;
            fromData['education'] = this.education;
            fromData['school'] = this.school;
            fromData['major'] = this.major;
            fromData['family'] = this.family;
            fromData['car'] = this.car;
            fromData['car_price'] = this.carPrice;
            fromData['house'] = this.car;
            fromData['house_price'] = this.housePrice;
            fromData['reside_code'] = this.adCodes;
            fromData['job_id'] = this.job;
            fromData['salary'] = this.salary;
            fromData['work_unit'] = this.work_unit;
            fromData['expect_min_salary'] = this.expectMinSalary;
            fromData['expect_min_education'] = this.expectMinEducation;
            fromData['expect_reside_province_id'] = this.expectResideProvinceId;
            fromData['expect_reside_city_id'] = this.expectResideCityId;
            fromData['expect_marriage'] = this.expectMarriage;
            fromData['expect_health'] = this.expectHealth;
            fromData['expect_min_height'] = this.expectMinHeight;
            fromData['expect_max_height'] = this.expectMaxHeight;
            fromData['expect_min_age'] = this.expectMinAge;
            fromData['expect_max_age'] = this.expectMaxAge;
            fromData['prove_marital'] = this.imageUrl;
            fromData['prove_marital_video'] = this.videoUrl;
            // console.log(fromData);
            try {
                ayzAjax.post('/user_prefill',fromData).then((response) => {
                    if(response.data.code !== 200){
                        showFailToast(response.data.msg)
                        return false;
                    }
                    this.isSubmit = true;
                    this.disabled = true;
                    showSuccessToast('预设数据已提交')
                })
            }catch(err) {
                console.log(err);
                showFailToast('网络错误,请稍后再试')
            }
        },
    }
}
</script>

<style scoped lang="scss" >
.join-view{
    display: flex;
    background: #F7F8FA;
    //padding-top: 40px;
}
.form-box{
    width: 100%;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .block {
        width: 100%;
        object-fit: fill;
        .close{
            color: #FFFFFF;
            text-align: left;
            margin-left: 45px;
        }
    }
}


</style>

